import { cn } from "@/lib/utils";
import { createElement, type ReactNode } from "react";

type Variant = "default" | "hero" | "tight";
type Tone = "default" | "inverse";

const VARIANT_CLASSES: Record<Variant, string> = {
  default: "py-20 lg:py-28 px-4 md:px-8 lg:px-12",
  hero: "pt-28 md:pt-32 lg:pt-36 pb-16 md:pb-20 lg:pb-24 px-4 md:px-8 lg:px-12",
  tight: "py-12 lg:py-16 px-4 md:px-8 lg:px-12",
};

type Props = {
  children: ReactNode;
  variant?: Variant;
  tone?: Tone;
  as?: "section" | "div" | "article" | "header" | "footer";
  className?: string;
  id?: string;
};

export function Section({
  children,
  variant = "default",
  tone = "default",
  as = "section",
  className,
  id,
}: Props) {
  const props: Record<string, unknown> = {
    id,
    className: cn(
      "relative w-full",
      VARIANT_CLASSES[variant],
      tone === "inverse" && "bg-brand-950 text-background",
      className,
    ),
  };

  if (tone === "inverse") {
    props["data-header-theme"] = "dark";
  }

  return createElement(as, props, children);
}
